import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {PasoWizard} from "../../interface/wizard-informacion.types";

@Component({
    selector: 'lib-stepps',
    templateUrl: './stepps.component.html',
    styleUrls: ['./stepps.component.css']
})
export class SteppsComponent implements OnInit {

    @Input()
    pasos: PasoWizard[];

    @Input()
    currentStep: number = 0;

    @Output()
    goToStep: EventEmitter<any> = new EventEmitter<any>();

    constructor() {
    }

    ngOnInit(): void {
    }

    /**
     * Track by function for ngFor loops
     *
     * @param index
     * @param item
     */
    trackByFn(index: number, item: any): any {
        return item.id || index;
    }

    validateDisable(step) {
        return step.requerido ? step.orden > this.currentStep : false;
        
    }
}
